import { LoadableLazy } from '@confluence/loadable';

export const LabelsValidationErrorLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-LabelsSelectErrors" */ './LabelsSelectErrors.tsx'))
			.LabelsValidationError,
});
